import { useCallback, useMemo, useState } from 'react';

import { DateTime } from 'luxon';

import { useDebouncedValue } from 'services/hooks';

import { CoursesFilterVariables } from './GetCourses';

export type MethodistFilterVariables = Pick<
  CoursesFilterVariables,
  'search' | 'courseId' | 'groupIds' | 'lessonDate'
>;

export const useMethodistFilters = () => {
  const [search, setSearch] = useState('');
  const [courseId, setCourseId] = useState('');
  const [groupId, setGroupId] = useState('');
  const [lessonDate, setLessonDate] = useState<Date | null>(null);

  const debouncedSearch = useDebouncedValue(search);

  const reset = useCallback(() => {
    setSearch('');
    setCourseId('');
    setGroupId('');
    setLessonDate(null);
  }, []);

  const filterVariables = useMemo<MethodistFilterVariables>(
    () => ({
      search: debouncedSearch.trim() || undefined,
      courseId: courseId || undefined,
      groupIds: groupId ? [groupId] : undefined,
      lessonDate: lessonDate ? DateTime.fromJSDate(lessonDate).toISODate() : undefined,
    }),
    [debouncedSearch, courseId, groupId, lessonDate],
  );

  const hasActiveFilters = Boolean(debouncedSearch.trim() || courseId || groupId || lessonDate);

  return {
    search,
    courseId,
    groupId,
    lessonDate,
    setSearch,
    setCourseId,
    setGroupId,
    setLessonDate,
    reset,
    filterVariables,
    hasActiveFilters,
  };
};
